import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SearchForm from "../../../common/SearchForm";
import { ShowNoContent } from "../../../common/statelessView";
import TLDRInfiniteGalleryGridLayout from "../../../common/TLDRInfiniteGalleryGridLayout";
import RecentlyUsedMedia from "../../../common/RecentlyUsedMedia";
import { Center, Spinner, useBoolean } from "@chakra-ui/react";

export function SuperList(props) {
  const {
    loaded,
    children,
    searchPlaceholder,
    errorsView,
    loadPage,
    hasMore,
    list,
    notFound,
    showNavigation,
    showRecents,
    onClickRecent,
    recentsWithoutDragAndDropContext,
    onDragRecent,
    margin,
  } = props;

  useEffect(() => {
    loadPage(1);
  }, []);

  const [recentsViewAll, setRecentsViewAll] = useBoolean(false);

  let renderListComponent = null;

  if (!recentsViewAll) {
    if (!loaded) {
      // If the items are not loaded then show spinner
      renderListComponent = (
        <Center h="100%" position="relative">
          <Spinner color="brand.primary" size="xl" />
        </Center>
      );
    } else {
      // If Items are loaded
      if (errorsView) {
        // If the error view
        renderListComponent = <>{errorsView}</>;
      } else if (children.length === 0) {
        // If the length of children is 0
        renderListComponent = (
          <Center h="100%">
            <ShowNoContent text={notFound} />
          </Center>
        );
      } else {
        // Else
        renderListComponent = (
          <TLDRInfiniteGalleryGridLayout
            className={list}
            hasMore={hasMore}
            loadPage={loadPage}
            loaded={loaded}
            margin={margin ? margin : 12}
          >
            {children}
          </TLDRInfiniteGalleryGridLayout>
        );
      }
    }
  }

  return (
    <>
      <SearchForm searchPlaceholder={searchPlaceholder} />
      <hr className="tldr-hr" style={{marginLeft:'4px',marginRight:'0px', width: `calc(100% - 24px)`, marginBottom:"1rem"}} />
      {showRecents && (
        <RecentlyUsedMedia
          onClickItem={onClickRecent}
          onDragItem={onDragRecent}
          withoutDragAndDropContext={recentsWithoutDragAndDropContext}
          onToggleViewAll={setRecentsViewAll.toggle}
          viewAll={recentsViewAll}
        />
      )}

      {showNavigation && <>{showNavigation}</>}

      {renderListComponent}
    </>
  );
}

SuperList.defaultProps = {
  margin: 12,
  showRecents: false,
};

SuperList.propTypes = {
  loaded: PropTypes.bool.isRequired,
  loadPage: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  list: PropTypes.string.isRequired,
  notFound: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  showRecents: PropTypes.bool,
  onClickRecent: PropTypes.func,
  recentsWithoutDragAndDropContext: PropTypes.bool,
  onDragRecent: PropTypes.func,
};

export default SuperList;
